/**
 * Validated payment date value object (ISO format string)
 */
export type PaymentDate = Readonly<string>;

/**
 * Creates a validated PaymentDate value object.
 *
 * @param raw - Raw date string in ISO format
 * @returns Validated PaymentDate
 * @throws Error if date format is invalid
 */
export const createPaymentDate = (raw: string): PaymentDate => {
  if (!raw?.trim()) {
    throw new Error('Payment date is required');
  }
  const date = new Date(raw);
  if (isNaN(date.getTime())) {
    throw new Error('Payment date must be a valid ISO date');
  }
  return raw as PaymentDate;
};
